import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/:id',
    name: 'file-check',
    component: () => import('@/pages/signer/check')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

export default router
